import { useEffect } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { FormSectionCard } from "../layout/page";
import { useForceUpdate } from "@mantine/hooks";
import { useFormRender } from "../hooks/useFormRender";

import { getFormSchema } from "./bankAccountTransactions";
import { useFormatter } from "../hooks/useFomatter";

import _ from "lodash";
import {
  Button,
  Group,
  Badge,
  Checkbox,
  Card,
  Text,
  Paper,
  Divider,
  ThemeIcon,
  Image,
  Tooltip,
} from "@mantine/core";
import { useCellRender } from "../hooks/useCellRender";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Grid } from "@mantine/core";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Menu, ActionIcon } from "@mantine/core";
import {
  IconDotsVertical,
  IconRefresh,
  IconCheck,
  IconAlertTriangle,
  IconPencil,
} from "@tabler/icons";
import { showNotification } from "@mantine/notifications";
import { ImageThumbList } from "./clientPaymentList";
import { buildMatchingPaymentSearchQuery } from "../helpers/clientPaymentMatching";
import ReactJson from "react-json-view";
import { ScrollArea } from "@mantine/core";
import { getFileIcon, getFileIconColor, isImageFile } from "./fileList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";

const ReceiptList = ({ files, size = 20, max = 2 }) => {
  const imageFiles = files?.filter((file) => isImageFile(file.mimetype));
  const otherFiles = files?.filter((file) => !isImageFile(file.mimetype));
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
      {imageFiles?.slice(0, max)?.map((file, index) => (
        <Image
          src={file.url}
          alt={`Thumbnail ${index + 1}`}
          width={size}
          height={size}
          fit="cover"
          onClick={() => {
            window.open(file.url, "_blank");
          }}
        />
      ))}
      {otherFiles?.slice(0, max)?.map((file, index) => (
        <FontAwesomeIcon
          key={index}
          icon={faFilePdf}
          alt={file.name}
          title={file.name}
          onClick={() => {
            window.open(file.url, "_blank");
          }}
          color={getFileIconColor(file.mimetype)}
          size="xs"
        />
      ))}
    </div>
  );
};

const MatchCard = ({ matching, onUndo, bankAccount, onConfirm, onUpdate }) => {
  const [cellRender] = useCellRender();
  const [api] = useServerApi();
  const forceUpdate = useForceUpdate();
  const formatter = useFormatter();

  const onFormSubmit = async ({ formMode, values }) => {
    console.log("onFormSubmit", values);
    try {
      const result = await api.updateById({
        apiEntity: "bankTransaction",
        id: matching.bankTransaction._id,
        values,
      });

      if (result) {
        onUpdate();
        showNotification({
          title: "Success",
          message: "Update bank transaction successfully",
          color: "green",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [renderForm, formAction, formStatus, formSetting] = useFormRender(
    getFormSchema(
      cellRender,
      formatter,
      matching.bankTransaction._id,
      matching.bankTransaction
    ),
    () => {},
    onFormSubmit,
    () => {}
  );

  const confirmMatching = async () => {
    try {
      // console.log("confirmMatching", matching);
      if (!bankAccount?._id) return;
      const result = await api.BankAccount.confirmMatching(
        matching,
        bankAccount._id
      );
      // console.log("result", result);
      if (onConfirm) onConfirm(matching.bankTransaction._id);
      showNotification({
        title: "Success",
        message: "Confirm matching successfully",
        color: "green",
      });
    } catch (error) {
      // console.log(error);
      showNotification({
        title: "Error",
        message: error,
        color: "red",
      });
    }
  };

  const undoMatching = () => {
    try {
      matching.payment.matched = false;
      matching.payment = null;

      matching.totalReceivedAmount =
        matching.bankTransaction.amount +
        (matching.bankTransaction.bankCharge ?? 0);

      matching.totalPaymentAmount = 0;
      matching.totalDifference = matching.totalReceivedAmount;
      if (onUndo) onUndo();
      forceUpdate();
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditBankDetails = () => {
    // console.log("edit bank details", matching.bankTransaction);
    formAction.open({
      mode: "edit",
      id: matching.bankTransaction._id,
      data: matching.bankTransaction,
    });
  };

  const { t } = useTranslation();
  const [forceConfirm, setForceConfirm] = useState(false);
  const transaction = matching.bankTransaction;
  const payment = matching.payment;
  const firstDN = !_.isEmpty(payment?.debitNoteAssignments)
    ? payment?.debitNoteAssignments[0]?.debitNote
    : null;
  return (
    <>
      {renderForm()}

      <Droppable droppableId={matching.id}>
        {(provided, snapshot) => (
          <Card my="md" {...provided.droppableProps} ref={provided.innerRef}>
            <Grid gutter="xs" columns={24} align="flex-start">
              <Grid.Col span={18}>
                {transaction && (
                  <Group position="apart" noWrap align="flex-start">
                    <Group
                      mb="md"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      align="flex-start"
                    >
                      <Badge radius="sm">{transaction.code} </Badge>
                      <Text size="xs">
                        {moment(transaction.date).format("YYYY-MM-DD")}
                      </Text>
                      <Text size="xs" weight="bold">
                        {cellRender.Currency(transaction.amount)}
                        {transaction.bankCharge > 0.01 && (
                          <>
                            <Text size="xs" color="dimmed">
                              Bank Charge:{" "}
                              {cellRender.Currency(transaction.bankCharge)}
                            </Text>
                            <Text size="xs" color="dimmed">
                              Total:{" "}
                              {cellRender.Currency(
                                transaction.amount +
                                  (transaction.bankCharge ?? 0)
                              )}
                            </Text>
                          </>
                        )}
                      </Text>

                      <Text size="xs" italic lineClamp={1}>
                        {transaction.detail}
                      </Text>
                    </Group>
                  </Group>
                )}

                {/* {matching.payment && <Divider mb="md" variant="dashed" />} */}

                {payment && (
                  <Draggable
                    key={payment._id}
                    draggableId={payment._id}
                    index={0}
                  >
                    {(provided, snapshot) => (
                      <>
                        <Group
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{ alignItems: "flex-start" }}
                        >
                          <Badge radius="sm" color="orange" mr={15}>
                            {payment.code}
                          </Badge>
                          <Text size="xs">
                            {moment(payment.date).format("YYYY-MM-DD")}
                          </Text>
                          <span>
                            <Text size="xs" weight="bold">
                              {cellRender.Currency(payment.amount)}
                            </Text>
                            {payment.adjustmentAmount &&
                              payment.adjustmentAmount !== 0 && (
                                <Text size="xs" color="dimmed">
                                  ({" "}
                                  {cellRender.Currency(
                                    payment.adjustmentAmount
                                  )}{" "}
                                  )
                                </Text>
                              )}
                          </span>
                          <Text size="xs" italic lineClamp={1} mt={1}>
                            {firstDN?.client?.name}
                          </Text>
                        </Group>
                      </>
                    )}
                  </Draggable>
                )}

                {payment && (
                  <>
                    <Group mt="xl" spacing={5}>
                      {matching.totalDifference === 0 ? (
                        <ThemeIcon color="green" size="xs" radius="xl">
                          <IconCheck size="1rem" />
                        </ThemeIcon>
                      ) : (
                        <ThemeIcon color="red" size="xs" radius="xl">
                          <IconAlertTriangle size="1rem" />
                        </ThemeIcon>
                      )}

                      <Text size="xs" weight="bold" mr="xl">
                        Amount
                      </Text>

                      <ThemeIcon
                        color={
                          moment(matching.payment.date).isSame(
                            matching.bankTransaction.date,
                            "day"
                          )
                            ? "green"
                            : "red"
                        }
                        size="xs"
                        radius="xl"
                      >
                        {moment(matching.payment.date).isSame(
                          matching.bankTransaction.date,
                          "day"
                        ) ? (
                          <IconCheck size="1rem" />
                        ) : (
                          <IconAlertTriangle size="1rem" />
                        )}
                      </ThemeIcon>
                      <Text size="xs" weight="bold" mr="xl">
                        Date
                      </Text>

                      {matching.totalDifference !== 0 && (
                        <Group position="apart" noWrap ml="xl">
                          <Badge color="red" radius="sm" size="xs">
                            {t("Difference")}
                          </Badge>
                          <Text size="xs" align="right">
                            {cellRender.Currency(matching.totalDifference)}
                          </Text>
                        </Group>
                      )}

                      <ReceiptList files={payment.files} />
                    </Group>
                  </>
                )}
              </Grid.Col>
              <Grid.Col span={5}>
                {matching.payment && (
                  <Group mb="xs" position="right">
                    <Button
                      size="xs"
                      fullWidth
                      onClick={() => confirmMatching()}
                      disabled={
                        !forceConfirm &&
                        Math.abs(
                          matching.totalReceivedAmount -
                            matching.totalPaymentAmount
                        ) > 0.001
                      }
                    >
                      Confirm
                    </Button>
                  </Group>
                )}

                {matching.totalDifference !== 0 && matching.payment && (
                  <Checkbox
                    mt="xs"
                    size="xs"
                    label="Force Confirm"
                    checked={forceConfirm}
                    defaultChecked={false}
                    onChange={(event) =>
                      setForceConfirm(event.currentTarget.checked)
                    }
                  />
                )}
              </Grid.Col>

              <Grid.Col span={1}>
                <Menu shadow="md" size="xs" withinPortal={true}>
                  <Menu.Target>
                    <ActionIcon size="xs">
                      <IconDotsVertical size="1rem" />
                    </ActionIcon>
                  </Menu.Target>

                  <Menu.Dropdown size="xs">
                    <Menu.Item
                      icon={<IconPencil size={12} />}
                      onClick={handleEditBankDetails}
                    >
                      Edit Details
                    </Menu.Item>
                    <Menu.Item
                      icon={<IconRefresh size={12} />}
                      onClick={() => undoMatching()}
                      disabled={!matching.payment}
                    >
                      Undo Matching
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Grid.Col>
            </Grid>
          </Card>
        )}
      </Droppable>
    </>
  );
};

const PaymentCard = ({ payment, index, droppableProps, innerRef }) => {
  const [cellRender] = useCellRender();

  const firstDN = !_.isEmpty(payment?.debitNoteAssignments)
    ? payment.debitNoteAssignments[0]?.debitNote
    : null;

  return (
    <Card my="md" style={{ overflow: "visible" }}>
      <Draggable key={payment._id} draggableId={payment._id} index={index}>
        {(provided, snapshot) => (
          <>
            {/* <ReactJson src={payment} style={{ background: "white" }} /> */}
            <Group
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <Badge radius="sm" color="orange">
                {payment.code}
              </Badge>
              <Text size="xs" fw={700}>
                {moment(payment.date).format("YYYY-MM-DD")}
              </Text>
              <Text size="xs" fw={700}>
                {cellRender.Currency(
                  payment.amount + (payment.adjustmentAmount ?? 0)
                )}
              </Text>

              <ReceiptList files={payment.files} />
            </Group>

            <Group>
              <Text size="xs" color="dimmed" lineClamp={1} mt="xs">
                {firstDN?.policyNumber ?? firstDN?.code}
              </Text>
              <Text size="xs" color="dimmed" lineClamp={1} mt="xs">
                {firstDN?.client?.name}
              </Text>
            </Group>
          </>
        )}
      </Draggable>
    </Card>
  );
};

const BankTransactionMatching = ({ bankAccount, type = "PAYMENT" }) => {
  const [api] = useServerApi();
  const [matchings, setMatchings] = useState([]);
  const [payments, setPayments] = useState([]);
  const [debitNotes, setDebitNotes] = useState([]);
  const [isAutoMatching, setIsAutoMatching] = useState(false);
  const { t } = useTranslation();
  const forceUpdate = useForceUpdate();

  const getMatchingTransaction = async () => {
    try {
      if (!bankAccount?._id) return;
      const result = await api.BankAccount.getMatchingTransaction(
        bankAccount?._id,
        type === "REFUND" ? "WITHDRAWAL" : "DEPOSIT"
      );
      // console.log(result);
      if (!result?.bankTransactions) return;
      const matchings = [];
      for (const [index, transaction] of result.bankTransactions.entries()) {
        matchings.push({
          id: `matching-${index}`,
          bankTransaction: transaction,
          payment: null,
          amount: transaction.amount,
          description: transaction.description,
          date: transaction.date,
          totalReceivedAmount: transaction.amount,
          bankCharge: transaction.bankCharge,
          totalPaymentAmount: 0,
          totalDifference: transaction.amount + (transaction.bankCharge ?? 0),
          matchedDate: transaction.matchedDate,
        });
      }
      setMatchings(matchings);
    } catch (error) {
      console.log(error);
    }
  };

  const getMatchingPayment = async () => {
    try {
      const result = await api.search({
        apiEntity: "clientPayment",
        pageSize: 1000,
        currentPage: 1,
        searchQuery: buildMatchingPaymentSearchQuery(bankAccount?._id, type),
        sort: { by: "date", order: "asc" },
        byAggregation: false,
      });
      // console.log("getMatchingPayment", result);
      if (!result || !result.docs) return;

      setPayments(result.docs);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getMatchingTransaction();
    getMatchingPayment();
  }, [bankAccount?.id]);

  const reMatch = async () => {
    try {
      await getMatchingTransaction();
      await getMatchingPayment();
    } catch (error) {
      console.log(error);
    }
  };

  const refresh = async () => {
    try {
      await getMatchingTransaction();
      await getMatchingPayment();
    } catch (error) {
      console.log(error);
    }
  };

  const handleDragEnd = (result) => {
    // console.log("handleDragEnd", result);
    const { destination, source, draggableId } = result;
    if (!destination || !source || !draggableId) return;
    if (source.droppableId === destination.droppableId) return;
    if (destination.droppableId === "PaymentList") return;

    //Source from other matching
    const sourceMatching = matchings.find((m) => m.id === source.droppableId);
    if (sourceMatching) return;

    //Source from payment list
    const sourcePayment = payments.find((d) => d._id === draggableId);

    const destinationMatching = matchings.find(
      (m) => m.id === destination.droppableId
    );

    // console.log(sourceMatching, destinationMatching, sourceDebitNote);

    if (!sourcePayment || !destinationMatching) return;

    const p = payments.find((d) => d._id === draggableId);
    if (!p) return;
    //Check if payment already in destination matching
    if (destinationMatching.payment) return;

    destinationMatching.payment = p;

    destinationMatching.totalReceivedAmount = _.round(
      destinationMatching.bankTransaction.amount +
        (destinationMatching.bankTransaction.bankCharge ?? 0),
      2
    );

    destinationMatching.totalPaymentAmount = _.round(
      destinationMatching.payment.amount +
        (destinationMatching.payment.adjustmentAmount ?? 0),
      2
    );

    destinationMatching.totalDifference = _.round(
      destinationMatching.totalReceivedAmount -
        destinationMatching.totalPaymentAmount,
      2
    );

    p.matched = true;
    forceUpdate();
  };

  const onConfirm = async (transactionId) => {
    const newMatchings = matchings.filter(
      (m) => m.bankTransaction._id != transactionId
    );

    setMatchings(newMatchings ?? []);
    forceUpdate();
  };

  const getSkipMatching = (payments, matchings) => {
    const paymentMap = new Map();
    for (const payment of payments) {
      const key = `${moment(payment.date).format("YYYY-MM-DD")}/${
        payment.amount
      }`;
      if (paymentMap.has(key)) {
        paymentMap.set(key, paymentMap.get(key) + 1);
      } else {
        paymentMap.set(key, 1);
      }
    }

    const transactionMap = new Map();
    for (const matching of matchings) {
      const key = `${moment(matching.date).format("YYYY-MM-DD")}/${
        matching.amount
      }`;
      if (transactionMap.has(key)) {
        transactionMap.set(key, transactionMap.get(key) + 1);
      } else {
        transactionMap.set(key, 1);
      }
    }

    const skipMatching = [];
    //COMPARE the count of payment and transaction , if count is not same , the skip in matching
    for (const [key, count] of transactionMap) {
      const paymentCount = paymentMap.get(key) || 0;
      if (paymentCount !== count) {
        skipMatching.push({
          date: key.split("/")[0],
          amount: Number(key.split("/")[1]),
        });
        continue;
      }
    }
    return skipMatching;
  };

  const autoMatch = async () => {
    try {
      setIsAutoMatching(true);
      // Create a Map for O(1) lookup instead of O(n) array iteration
      const paymentsByDateAmount = new Map();

      // Group unmatched payments by date-amount key
      for (const payment of payments) {
        if (payment.matched) continue;

        const dateKey = moment(payment.date).format("YYYY-MM-DD");
        const key = `${dateKey}:${payment.amount}`;

        if (!paymentsByDateAmount.has(key)) {
          paymentsByDateAmount.set(key, []);
        }
        paymentsByDateAmount.get(key).push(payment);
      }

      // Batch all matches before applying
      const matchesToApply = [];
      const matchLimit = 100; // Process in batches to avoid browser freeze

      for (const matching of matchings) {
        if (matchesToApply.length >= matchLimit) break;

        const dateKey = moment(matching.date).format("YYYY-MM-DD");
        const key = `${dateKey}:${matching.totalDifference}`;

        const availablePayments = paymentsByDateAmount.get(key);
        if (availablePayments && availablePayments.length > 0) {
          const payment = availablePayments.shift(); // Take first available
          matchesToApply.push({
            matching,
            payment,
          });
        }
      }

      // Apply all matches in a single batch update
      matchesToApply.forEach(({ matching, payment }) => {
        handleDragEnd({
          destination: { droppableId: matching.id },
          source: { droppableId: payment._id },
          draggableId: payment._id,
        });
      });

      forceUpdate();
      showNotification({
        title: "Auto Match Complete",
        message: `Matched ${matchesToApply.length} transactions`,
        color: "green",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setIsAutoMatching(false);
    }
  };

  return (
    <>
      <Group position="right" spacing={5}>
        <Button
          size="xs"
          onClick={() => autoMatch()}
          color="green"
          loading={isAutoMatching}
          disabled={matchings.length === 0 || payments.length === 0}
        >
          Auto Match
        </Button>
        <Button size="xs" onClick={() => refresh()} variant="default">
          Refresh
        </Button>

        <Menu shadow="md" width={200}>
          <Menu.Target>
            <ActionIcon>
              <IconDotsVertical size="1rem" />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Item
              icon={<IconRefresh size={14} />}
              onClick={() => reMatch()}
            >
              Reset
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>

      <DragDropContext onDragEnd={handleDragEnd}>
        <Grid>
          <Grid.Col span={8}>
            <>
              <Group>
                <Text size="xs" weight="bold">
                  {t("Bank Transactions")}
                </Text>
                <Badge radius="sm" size="xs">
                  {matchings?.length ?? 0}
                </Badge>
              </Group>

              <ScrollArea style={{ height: "calc(100vh - 200px)" }}>
                {matchings &&
                  matchings?.map((matching) => (
                    <MatchCard
                      key={matching.id}
                      matching={matching}
                      onUndo={() => forceUpdate()}
                      bankAccount={bankAccount}
                      onConfirm={(transactionId) => onConfirm(transactionId)}
                      onUpdate={() => refresh()}
                    />
                  ))}
              </ScrollArea>
            </>
          </Grid.Col>
          <Grid.Col span={4}>
            <>
              <Group>
                <Text size="xs" weight="bold">
                  {t("Client Payments")}
                </Text>
                <Badge radius="sm" size="xs" color="orange">
                  {payments?.filter((d) => !d.matched)?.length}
                </Badge>
              </Group>

              <ScrollArea style={{ height: "calc(100vh - 200px)" }}>
                {payments && payments?.length > 0 && (
                  <Droppable droppableId={"PaymentList"} dropabled={false}>
                    {(provided, snapshot) => (
                      <div {...provided.droppableProps} ref={provided.innerRef}>
                        {payments
                          ?.filter((d) => !d.matched)
                          ?.map((payment, index) => (
                            <PaymentCard
                              key={payment._id}
                              payment={payment}
                              index={index}
                            />
                          ))}
                      </div>
                    )}
                  </Droppable>
                )}
              </ScrollArea>
            </>
          </Grid.Col>
        </Grid>
      </DragDropContext>
    </>
  );
};

export default BankTransactionMatching;
